export const experienceData = [
    {
        id: 1,
        company: 'ADP',
        jobtitle: 'Software Developer',
        startYear: 'Dec 2020',
        endYear: 'Dec 2022'
    },
    {
        id: 2,
        company: 'SmartBridge',
        jobtitle: 'Java Developer',
        startYear: 'May 2018',
        endYear: 'Nov 2020'
    }
]